<!-- <div style="display: flex; padding: 25px;">
    <button style="margin-left: 10px; margin-right: 10px;"  (click)="changeStatus(status - 1)"> - 1 </button>
    <button style="margin-left: 10px; margin-right: 10px;"> {{ status }} </button>
    <button style="margin-left: 10px; margin-right: 10px;" (click)="changeStatus(status + 1)"> + 1 </button>
    <form (ngSubmit)="changeStatus(input.value)" >
        <input #input placeholder="introduce el estado">
    </form>
    <button style="margin-left: 10px; margin-right: 10px;" (click)="changeStatus(input.value)">cambiar </button>
</div> -->

<div class="steps">
  <nav class="steps-bar-wrapper">
    <ul class="steps-bar">
      <li class="circle">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('1')"
          [title]="'status_bar_record_your_data' | translate"
        >
          <span [class.done]="status >= minStatus?.saveData"></span>

          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_record_your_data' | translate }} </span>
          }

          @if (isRejected && status >= minStatus?.attachDocumentation) {
            <span class="status-link">
              {{ 'status_bar_record_your_data' | translate }}
            </span>
          }

          @if (isRejected && status < minStatus?.attachDocumentation) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
      <li class="steps-bar__bar" [class.done]="status >= minStatus?.attachDocumentation"></li>

      <li class="circle" [ngClass]="{ done: status >= minStatus?.finalizeAttachDocumentation }">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('2')"
          [title]="'status_bar_send_document' | translate"
        >
          <span
            [ngClass]="{
              done: status >= minStatus?.finalizeAttachDocumentation,
              'circle-left': status >= minStatus?.attachDocumentation,
            }"
          ></span>
          <!-- <span class="status-link">{{ 'status_bar_send_document' | translate }}</span> -->
          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_send_document' | translate }} </span>
          } @else if (isRejected && status > minStatus?.finalizeAttachDocumentation) {
            <span class="status-link">
              {{ 'status_bar_send_document' | translate }}
            </span>
          }

          @if (
            isRejected && status >= minStatus?.attachDocumentation && status < minStatus?.finalizeAttachDocumentation
          ) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
      <li class="steps-bar__bar" [class.done]="status >= minStatus?.finalizeAttachDocumentation"></li>

      <li class="circle" [ngClass]="{ done: status >= minStatus?.appraisal }">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('3')"
          [title]="'status_bar_review' | translate"
        >
          <span
            [ngClass]="{
              done: status >= minStatus?.appraisal,
              'circle-left': status >= minStatus?.finalizeAttachDocumentation,
            }"
          ></span>
          <!-- <span class="status-link">{{ 'status_bar_review' | translate }}</span> -->
          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_review' | translate }} </span>
          } @else if (isRejected && status >= minStatus?.appraisal) {
            <span class="status-link">
              {{ 'status_bar_review' | translate }}
            </span>
          }

          @if (isRejected && status >= minStatus?.finalizeAttachDocumentation && status < minStatus?.appraisal) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
      <li class="steps-bar__bar" [class.done]="status >= minStatus?.appraisal"></li>
      <li class="circle" [class.done]="status >= minStatus?.appraisal">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('4')"
          [title]="'status_bar_appraisal' | translate"
        >
          <span
            [ngClass]="{ done: status >= minStatus?.signature, 'circle-left': status >= minStatus?.appraisal }"
          ></span>
          <!-- <span class="status-link">{{ 'status_bar_appraisal' | translate }}</span> -->

          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_appraisal' | translate }} </span>
          } @else if (isRejected && status >= minStatus?.signature) {
            <span class="status-link">
              {{ 'status_bar_appraisal' | translate }}
            </span>
          } @else if (isRejected && status >= minStatus?.appraisal && status < minStatus?.signature) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
      <li class="steps-bar__bar" [class.done]="status >= minStatus?.signature"></li>
      <li class="circle" [class.done]="status >= minStatus?.signature">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('5')"
          [title]="'status_bar_signature' | translate"
        >
          <span
            [ngClass]="{ done: status >= minStatus?.inscription, 'circle-left': status >= minStatus?.signature }"
          ></span>
          <!-- <span class="status-link"> {{ 'status_bar_signature' | translate }}</span> -->

          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_signature' | translate }} </span>
          } @else if (isRejected && status >= minStatus?.inscription) {
            <span class="status-link">
              {{ 'status_bar_signature' | translate }}
            </span>
          } @else if (isRejected && status >= minStatus?.signature && status < minStatus?.inscription) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
      <li class="steps-bar__bar" [class.done]="status >= minStatus?.inscription"></li>
      <li class="circle" [class.done]="status >= minStatus?.inscription">
        <a
          class="steps-bar__link"
          href="javascript:void(0)"
          (click)="openModalGeneric('6')"
          [title]="'status_bar_inscription' | translate"
        >
          <span
            [ngClass]="{ done: status >= minStatus?.inscription + 1, 'circle-left': status >= minStatus?.inscription }"
          ></span>
          <!-- <span class="status-link">{{ 'status_bar_inscription' | translate }}</span> -->
          @if (!isRejected) {
            <span class="status-link"> {{ 'status_bar_inscription' | translate }} </span>
          } @else if (isRejected && status > minStatus?.inscription) {
            <span class="status-link">
              {{ 'status_bar_inscription' | translate }}
            </span>
          } @else if (isRejected && status === minStatus?.inscription) {
            <span class="status-link">
              {{ 'Rechazada' | translate }}
            </span>
          }
        </a>
      </li>
    </ul>
  </nav>
</div>
